import { render } from "./ModalProfPlaceInsurance.vue?vue&type=template&id=50c80312"
import script from "./ModalProfPlaceInsurance.vue?vue&type=script&lang=js"
export * from "./ModalProfPlaceInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__